module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/hero-800-b00fca870a06a690a104f07349cdc660.jpg";